<div class="logo-area" [routerLink]='""' (click)="resetContext()">
  <img src="assets/img/OmsMapGreenDot.svg" />
</div>
@if (currentContext$ | async; as currentContext) {
  @for (menuItem of menuItems; track trackByFunction($index, menuItem)) {
    @if (
      !menuItem.hasAccess
      || (menuItem.hasAccess === 'TaWriter'
      && (hasTrafficDeviationRegion$ | async)
      && hasAccess[menuItem.hasAccess])
      || menuItem.hasAccess !== 'TaWriter' && hasAccess[menuItem.hasAccess]) {
      <div
        class="context-menu-item"
        [class.selected]="menuItem.context === currentContext"
        [matTooltip]="menuItem.tooltip | translate"
        matTooltipPosition="right"
        (click)="changeContext(menuItem)"
        >
        @if (menuItem.badge) {
          @if (menuItem.icon) {
            <div class="icon"
              matBadgeSize="medium"
              matBadgeOverlap="false"
              [matBadge]="menuItem.badgeText"
              matBadgeColor="warn">
              <i [class]="menuItem.icon"></i>
            </div>
          }
          @if (menuItem.materialIcon) {
            <div class="material-icons"
              matBadgeSize="medium"
              matBadgeOverlap="false"
              [matBadge]="menuItem.badgeText"
              matBadgeColor="warn">
              {{ menuItem.materialIcon }}
            </div>
          }
        } @else {
          @if (menuItem.icon) {
            <div class="icon"><i [ngClass]="menuItem.icon"></i></div>
          }
          @if (menuItem.materialIcon) {
            <div class="material-icons">{{ menuItem.materialIcon }}</div>
          }
        }
      </div>
    }
  }
  <div class="bottom">
    @for (bottomItem of bottomMenuItems; track trackByFunction($index, bottomItem)) {
      @if (!bottomItem.hasAccess || bottomItem.hasAccess && hasAccess[bottomItem.hasAccess]) {
        <div
          class="context-menu-item"
          [class.selected]="bottomItem.context === currentContext"
          (click)="changeContext(bottomItem)"
          >
          <div class="icon"><i [ngClass]="bottomItem.icon"></i></div>
        </div>
      }
    }
  </div>
}
